import { removeLastSlash, removeLinkParams } from './link';
const baseDeezerPath = 'deezer.com/';
const baseEmbeddedPath = 'https://widget.deezer.com/widget/auto/';
const createEmbeddedLink = (link) => {
    const paths = removeLastSlash(removeLinkParams(link))
        ?.split(baseDeezerPath)[1]
        .split('/');
    const finalPath = paths && paths.length > 1
        ? `${paths[paths.length - 2]}/${paths[paths.length - 1]}`
        : undefined;
    const isArtist = finalPath?.startsWith('artist/');
    return finalPath
        ? `${baseEmbeddedPath}${finalPath}${isArtist ? '/top_tracks' : ''}?tracklist=true`
        : undefined;
};
export const deezer = {
    category: 'AUDIO',
    isSatisfied: (link) => link.includes(baseDeezerPath),
    getPlayerExecutionProps: (link) => ({
        link: createEmbeddedLink(link),
        allowProps: 'encrypted-media; clipboard-write',
        responsive: true,
        height: 300,
    }),
};
